import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import { SpecimenDetailMobileGeneralProps } from 'pages/Bioregion/Specimen//SpecimenDetailsMobileLayout';
import { NatureCulture } from 'pages/Bioregion/Specimen/SpecimenOverviewTabDesktop';
import { Fragment, useMemo } from 'react';
import { Card } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { SpecimenUploadedResource } from 'services/graphqltypes';

/** This component renders the "Info" tab in mobile view of specimen details. */
const SpecimenInfoMobile = ({ goBackLink, hasEditPermission, specimanBySlug, showInQuestStop }: SpecimenDetailMobileGeneralProps) => {
  const { commonsSlug, slug } = useParams() as any;

  const { specimenNatureResources, specimenCultureResources }: {
    specimenNatureResources: SpecimenUploadedResource[],
    specimenCultureResources: SpecimenUploadedResource[]
  } = useMemo(() => {
    const specimenNatureResources = specimanBySlug?.specimenUploadedResourcesBySpecimenId?.
      nodes.filter((resource: SpecimenUploadedResource) =>
        resource.type === 'NATURE') || [];

    const specimenCultureResources = specimanBySlug?.specimenUploadedResourcesBySpecimenId?.
      nodes.filter((resource: SpecimenUploadedResource) =>
        resource.type === 'CULTURE') || [];

    return { specimenNatureResources, specimenCultureResources };

  }, [specimanBySlug]
  );

  return (
    <Fragment>
      <Card.Body className='p-2' style={{ maxHeight: '60%', height: '100%' }}>
        {/* Buttons */}
        {!showInQuestStop &&
          <div className='d-flex justify-content-between p-2'>

            {/* Back button */}
            <Link
              to={goBackLink}
              className='btn btn-xs rounded-circle badge-outline-dark p-0'
              style={{ aspectRatio: '1/1', backgroundColor: 'white' }}
            >
              <ChevronLeftIcon size={30} color='#909090' />
            </Link>

            {/* Edit button */}
            {hasEditPermission &&
              <Link
                to={`/commons/${commonsSlug}/specimen/edit/${slug}`}
                className='btn btn-xs rounded-circle badge-outline-orange p-0'
                style={{ aspectRatio: '1/1', backgroundColor: '#EFB700' }}
              >
                <EditOutlineIcon size={30} className='p-1' color='white' />
              </Link>}
          </div>
        }
        {/* Nature - doesn't show for POIs*/}
        {specimanBySlug.type !== 'POI' &&
          <>
            <NatureCulture
              titleTranslationId={'species.nature'}
              description={specimanBySlug.natureDescription}
              specimenResources={specimenNatureResources}
              contextHelpId='cc009079-4cab-4864-9f8c-981a807cce43'
            />
            {/* separator */}
            <div className="border-bottom my-4 mx-2" />
          </>
        }
        {/* Culture // For POI: Description */}
        <NatureCulture
          titleTranslationId={specimanBySlug.type !== 'POI' ? 'species.culture' : 'route.quest-description'}
          description={specimanBySlug.cultureDescription}
          specimenResources={specimenCultureResources}
          contextHelpId={specimanBySlug.type !== 'POI' ? '59f06ba8-4531-40bc-862c-bf80d3839a76' : '15828c52-dd7c-4f19-b17e-9a2ce7836bc8'}
        />
      </Card.Body>
    </Fragment>
  );
};

export default SpecimenInfoMobile;
